export const types = {
    busqueda : '[Results] busqueda',
    fin: '[Results] fin'
  }